import {createContext} from 'react'

interface DocumentLoadDetailContextProps {
  documentoArray: Record<string, any>[]
  setDocumentoArray: (value: Record<string, any>[]) => void
  showFile2Modal: boolean
  setShowFile2Modal: React.Dispatch<React.SetStateAction<boolean>>
  loadingNewPdf: boolean
  setLoadingNewPdf: React.Dispatch<React.SetStateAction<boolean>>
  selectedPlantillaId: string
  setSelectedPlantillaId: React.Dispatch<React.SetStateAction<string>>
  data: any
}

const DocumentLoadDetailContext = createContext<DocumentLoadDetailContextProps>({
  documentoArray: [],
  setDocumentoArray: () => {},
  showFile2Modal: false,
  setShowFile2Modal: () => {},
  loadingNewPdf: false,
  setLoadingNewPdf: () => {},
  selectedPlantillaId: '',
  setSelectedPlantillaId: () => {},
  data: {},
})

export {DocumentLoadDetailContext}
